import { BaseApi } from './base.api.js';

export class AuditPlanApi extends BaseApi {
    constructor(client) {
        super(client, '/audit-plan');
    }
}
